// components/CourseCard.jsx
import React from "react";
import { DateUtility } from "../helpers/commonFunction";
import courseImg from "../images/dummyCourse.jpg";

const CourseCard = (props) => {
  const { type, count, course, onClick } = props;
  return (
    <div
      className="d-flex border border-2 rounded bg-white border-green h-100 cursor-pointer lms-cousrse-card"
      onClick={() => onClick(course)}
    >
      <div className="flex-shrink-0 course-img">
        <img
          src={courseImg}
          alt={course.name}
          className="img-fluid object-fit-cover rounded"
        />
      </div>
      <div className="p-3 course-content d-flex flex-column lms-cousrse-content-wrapper">
        <h5 className="mb-2">{course.name}</h5>
        <p className="mb-2">{course.description}</p>
        <div className="d-flex justify-content-between small mt-auto gap-1">
          <span className="text-danger fw-semibold">
            {count}{" "}
            {`${type === "course" ? "Module" : "Video"}${count > 1 ? "s" : ""}`}
          </span>
          <span className="text-primary fw-semibold">
            {DateUtility.fullMDayYear(course?.created_at)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
